import React from 'react'
import PropTypes from 'prop-types'

export const SearchIcon = ({ type = 'line', height = 24, width = 24, color = '#666666', ...rest }) => {
	if (type === 'bold') {
		return (
			<svg width={height} height={width} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9 2C12.859 2 16 5.14 16 9C16 12.859 12.859 16 9 16C5.14 16 2 12.859 2 9C2 5.14 5.14 2 9 2ZM9 18C11.131 18 13.089 17.251 14.633 16.008L22.291 23.706C22.68 24.097 23.312 24.099 23.705 23.708C24.097 23.319 24.098 22.685 23.709 22.294L16.041 14.588C17.264 13.052 18 11.111 18 9C18 4.037 13.963 0 9 0C4.037 0 0 4.037 0 9C0 13.962 4.037 18 9 18Z"
					fill={color}
				/>
			</svg>
		)
	}
	return (
		<svg width={height} height={width} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.1464 14.8535C12.645 16.1888 10.6672 17 8.5 17C3.80586 17 0 13.1941 0 8.5C0 3.80519 3.80552 0 8.5 0C13.1945 0 17 3.80519 17 8.5C17 10.6672 16.1888 12.645 14.8535 14.1464L23.8538 23.1466C24.049 23.3419 24.049 23.6585 23.8538 23.8538C23.6585 24.049 23.3419 24.049 23.1466 23.8538L14.1464 14.8535ZM8.5 1C12.6422 1 16 4.3575 16 8.5C16 10.5611 15.1684 12.4282 13.8224 13.7839C13.8157 13.7899 13.8091 13.7962 13.8026 13.8026C13.7962 13.8091 13.7899 13.8157 13.7839 13.8224C12.4282 15.1684 10.5611 16 8.5 16C4.35814 16 1 12.6419 1 8.5C1 4.3575 4.35779 1 8.5 1Z"
				fill={color}
			/>
		</svg>
	)
}

SearchIcon.propTypes = {
	type: PropTypes.oneOf(['line', 'bold']),
	onClick: PropTypes.func,
	height: PropTypes.number,
	width: PropTypes.number,
	color: PropTypes.string,
}
